import { useFormikContext } from 'formik';
import type { Image } from './types';
import { IVariantInitialValuesProps } from '../../views/Product/types';
import { useImages } from './ImagesProvider';

/**
 * Formik bridge for the variant image. Stateless — everything derives from
 * the variant form context plus the shared image library, so this is a hook
 * rather than another provider layer.
 */
export const useVariantImage = () => {
    const { values, setFieldValue } = useFormikContext<IVariantInitialValuesProps>();
    const { fetchMoreImages, images } = useImages();

    const variantImageId = values.variant.imageId ?? null;
    const variantImage: Image | null = variantImageId
        ? images.find(image => image.id === variantImageId) ?? null
        : null;

    const setVariantImageId = (imageId: string | null) => {
        setFieldValue('variant.imageId', imageId);
    };

    return { variantImageId, variantImage, setVariantImageId, fetchMoreImages };
};
